module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar arquivo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('input', {
    ref: "arquivoInput",
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "id": "uploadFileInput",
      "type": "file",
      "accept": _vm.tiposArquivosPermitidos
    },
    on: {
      "change": function($event) {
        return _vm.adicionarArquivos($event.target.files)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo do arquivo",
      "items": _vm.listaTipoArquivo,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "autocomplete": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo.tipoArquivo),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoArquivo", $$v)
      },
      expression: "arquivo.tipoArquivo"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nível de acesso",
      "items": _vm.listaNivelAcesso,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "vpn_key",
      "max-height": "400",
      "autocomplete": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo.nivelAcesso),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "nivelAcesso", $$v)
      },
      expression: "arquivo.nivelAcesso"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de cópia",
      "items": _vm.listaTipoCopia,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "file_copy",
      "max-height": "400",
      "autocomplete": ""
    },
    model: {
      value: (_vm.arquivo.tipoCopia),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoCopia", $$v)
      },
      expression: "arquivo.tipoCopia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.arquivo.observacao),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "observacao", $$v)
      },
      expression: "arquivo.observacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.enviarArquivo
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5468abf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/upload-arquivo.vue
// module id = 435
// module chunks = 0